import React from 'react';
import AIStreamingResponse from './AIStreamingResponse';
import './aiImprove.css';

/**
 * Side-by-side Original / AI Version preview.
 * Never overwrites the editor until the user confirms.
 */
export default function AIPreviewModal({
  open,
  original = '',
  aiText = '',
  streaming = false,
  loading = false,
  error = '',
  onReplace,
  onAppend,
  onCopy,
  onRegenerate,
  onUndo,
  onCancel,
  canUndo = false,
}) {
  if (!open) return null;

  return (
    <div className="aii-preview" role="dialog" aria-label="AI writing preview">
      <div className="aii-preview-head">
        <h3>Preview</h3>
        <p>Review the AI version before changing your draft.</p>
      </div>

      {error && <div className="aii-error">{error}</div>}

      <div className="aii-preview-grid">
        <div className="aii-preview-col">
          <div className="aii-stream-label">Original</div>
          <div className="aii-preview-original">{original || '—'}</div>
        </div>
        <div className="aii-preview-col">
          <AIStreamingResponse
            text={aiText}
            streaming={streaming}
            loading={loading}
            label="AI Version"
          />
        </div>
      </div>

      <div className="aii-preview-actions">
        <button
          type="button"
          className="aii-btn aii-btn-primary"
          onClick={onReplace}
          disabled={!aiText || streaming || loading}
        >
          Replace
        </button>
        <button
          type="button"
          className="aii-btn aii-btn-secondary"
          onClick={onAppend}
          disabled={!aiText || streaming || loading}
        >
          Append
        </button>
        <button
          type="button"
          className="aii-btn aii-btn-ghost"
          onClick={onCopy}
          disabled={!aiText}
        >
          Copy
        </button>
        <button
          type="button"
          className="aii-btn aii-btn-ghost"
          onClick={onRegenerate}
          disabled={streaming || loading}
        >
          Regenerate
        </button>
        <button
          type="button"
          className="aii-btn aii-btn-ghost"
          onClick={onUndo}
          disabled={!canUndo}
        >
          Undo
        </button>
        <button type="button" className="aii-btn aii-btn-ghost" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
